import React, { FC, ReactNode } from 'react'
import '../icon.scss'

export const IV24ErrorIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container iv24-icon-container'>
      <img
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/92831e5a1038cce8b551b6e81cf32a63_iv24-rz-80.svg'
        }
        alt={''}
      />
    </div>
  )
}
